import React, { forwardRef, useState, } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import QualysInfraMappingForm from './QualysInfraMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import { Alert } from 'antd';

function QualysInfraCredentialsForm(props, ref) {
    const [checked, setChecked] = useState(props.config?.fetchAssets === "true");
    const [disabled] = useState(props.config?.fetchAssets === "true");
    const featureFlags = useFeatureFlag();
    const [password, setPassword] = useState();

    const fields = [{
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules:[urlRegexValidator],
    },{
        name: "username",
        label: "Username",
        required: true
    }, {
        name: "password",
        label: "Password",
        type: FieldTypes.PASSWORD,
        required: true,
        props: {
            onChange: (e) => setPassword(e.target.value) 
        }
    },  
    ...(featureFlags.RBVM_ASSETS
        ? [
            {
              name: "fetchAssets",
              label: "Fetch Assets",
              type: FieldTypes.BOOLEAN,
              inline: true,
              disabled: !password,
              props: {
                onChange: (e) => setChecked(e.target.checked),
              },
            },
            ...(checked
            ? 
            [{
                name: "assetTags",
                label: "Tags",
                help: "Enter comma separated tags",
                disabled: disabled && !password,
            }] 
            :
            [])
        ] 
        :
        []
    ),  
    {
        name: "message",
        type: FieldTypes.LABEL,
        value: <Alert type='warning' message="Projects for this integration will be available after few minutes of adding the credentials, since they are pulled in background."/>
    }];

    const parseExtraFields = (config) => {
            return {
            ...config,
            fetchAssets: Boolean(props.config?.fetchAssets === "true"),
            assetTags: config.assetTags,
            }
    };

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={QualysInfraMappingForm}
            initialValue={{ apiEndpoint: 'https://qualysapi.qg3.apps.qualys.com' }}
            parseExtraFields={parseExtraFields}
        />
    )
}

export default forwardRef(QualysInfraCredentialsForm);